import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <span className="font-heading text-xl font-bold text-white">
                佐佐木明希
              </span>
              <span className="ml-2 text-xs px-2 py-0.5 rounded-full bg-primary-500/20 text-primary-300 font-label">
                FAN CLUB
              </span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed">
              佐佐木明希官方粉丝资料站，一站式掌握个人档案、代表作品、最新动态等全部信息，持续更新中。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors duration-200 cursor-pointer"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-line"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors duration-200 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-heading font-semibold mb-4 text-sm">
              <a href="/category/all" className="hover:text-primary-400 transition-colors cursor-pointer">作品分类</a>
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: '全部作品', href: '/category/all' },
                { label: '剧情系列', href: '/category/drama' },
                { label: '恋爱系列', href: '/category/romance' },
                { label: '职场系列', href: '/category/office' },
                { label: '精选推荐', href: '/category/featured' },
              ].map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    className="text-foreground-400 text-sm hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-heading font-semibold mb-4 text-sm">
              <Link to="/about" className="hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link>
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: '品牌介绍', href: '/about' },
                { label: '口碑评价', href: '/about' },
                { label: '联系我们', href: '/about' },
              ].map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    className="text-foreground-400 text-sm hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-heading font-semibold mb-4 text-sm">最新动态</h4>
            <ul className="space-y-2.5">
              {[
                { label: '新闻资讯', href: '/category/news' },
                { label: '专题报道', href: '/category/news' },
                { label: '活动信息', href: '/category/news' },
                { label: '访谈实录', href: '/category/news' },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.href}
                    className="text-foreground-400 text-sm hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">
            &copy; {currentYear} 佐佐木明希粉丝站. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="/about" className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="/about" className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors cursor-pointer">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}